import React from "react";
import CategoriesCarousel from "../../Components/organisms/Home/CategoriesCarousel/CategoriesCarousel";
import CountDown from "../../Components/organisms/Home/CountDown/CountDown";
import Highlights from "../../Components/organisms/Home/Highlights/Highlights";
import Numbers from "../../Components/organisms/Home/Numbers/Numbers";
import Numbers2024 from "../../Components/organisms/Home/Numbers2024/Numbers2024";
import Ranking from "../../Components/organisms/Home/Ranking/Ranking";
import Reviews from "../../Components/organisms/Home/Reviews/Reviews";
import Theme from "../../Components/organisms/Home/Theme/Theme";
import Cover from "../../Components/organisms/Home/Cover/Cover";
import LogoCarouse from "../../Components/organisms/Home/LogoCarousel/LogoCarousel";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Images } from "../../helpers/Images";
import { useNavigate } from "react-router-dom";

export const Steps = [
  {
    title: "Register Your Team",
    desc: "Form a team and sign up for the competition.",
  },
  {
    title: "Build & Program",
    desc: "Create a robot that completes the assigned challenge.",
  },
  {
    title: "Compete! ",
    desc: "Present your project and compete against other teams in a fun competition.",
  },
  {
    title: "Win & Celebrate ",
    desc: "Get recognized for creativity, teamwork, and technical skills!",
  },
];

const HomeTemplate = () => {
  const navigate = useNavigate();
  return (
    <>
      <CountDown />
      <Theme />
      <Box
        sx={{
          background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)), url(${Images.wedo})`,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            padding: {
              xs: "30px 20px 30px",
              sm: "50px 60px 50px",
              lg: "50px 120px 50px",
            },
            maxWidth: "1400px",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant={"h2"}
            sx={{
              fontWeight: "800",
              color: "#fff",
              fontSize: { xs: "28px", md: "50px" },
              textAlign: "center",
            }}
          >
            Let's See How It Work!
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
              maxWidth: "1000px",
              margin: { xs: "10px auto 0", md: "20px auto 0" },
              alignItems: "flex-start",
            }}
          >
            {Steps?.map((ser, i) => (
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ position: "relative" }}>
                  <span
                    style={{
                      fontSize: "75px",
                      fontWeight: "800",
                      position: "absolute",
                      top: "-45px",
                      left: "5px",
                      color: "#23aef499",
                    }}
                  >
                    0{i + 1}
                  </span>
                  <Typography
                    variant={"h2"}
                    sx={{
                      fontWeight: "800",
                      color: "#fff",
                      fontSize: { xs: "17px", md: "22px" },
                      marginTop: "40px",
                      position: "relative",
                      left: "40px",
                      maxWidth: "80%",
                    }}
                  >
                    {ser?.title}
                  </Typography>
                  <Typography
                    variant={"p"}
                    sx={{
                      fontWeight: "200",
                      color: "#ffffffcc",
                      fontSize: { xs: "12px", md: "15px" },
                      position: "relative",
                      left: "40px",
                      display: "block",
                      maxWidth: "80%",
                      marginTop: "8px",
                    }}
                  >
                    {ser?.desc}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              margin: "0 auto",
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={() => navigate("/firststage")}
              sx={{
                fontSize: "15px",
                margin: "25px 0 0",
                fontWeight: "600",
                backgroundColor: "secondary.main",
                color: "#23aef4",
              }}
            >
              register now
            </Button>
          </Box>
        </Box>
      </Box>
      <Numbers />
      <Cover />
      {/* <Numbers2024 /> */}
      <CategoriesCarousel />
      {/* <Ranking /> */}
      {/* <LogoCarouse /> */}
      <Highlights />
      <Reviews />
    </>
  );
};

export default HomeTemplate;
